module.exports = __webpack_public_path__ + "img/play.70373e56.png";